import { alpha, Select, styled } from '@mui/material';

export const StyledSelect = styled(Select)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  '& .MuiDivider-root': {
    backgroundColor: theme.palette.divider,
  },
  '& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected.Mui-focusVisible': {
    // TODO: no VDS token for this value — needs designer input (#ccf0f9 light secondary blue)
    backgroundColor: alpha('#ccf0f9', 0.6),
  },
  '& .MuiButtonBase-root.MuiMenuItem-root.Mui-selected': {
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.palette.primary.main} !important`,
  },
}));
